export enum ScannedPropertyQrCodeSheetType {
    PropertyStorageLocationQrSheet = 'PropertyStorageLocationQrSheet',
    PropertyTransferReasonQrSheet = 'PropertyTransferReasonQrSheet',
    PropertyStatusQrSheet = 'PropertyStatusQrSheet',
    PropertyActionQrSheet = 'PropertyActionQrSheet',
    EmployeeQrSheet = 'EmployeeQrSheet',
}